// import { $ } from '../../../shared/js/utils/dom';
// import Bus from '../../../shared/js/modules/event-bus';
import { Lightbox } from '@3pc/lightbox-photoswipe';
import { config, fixCounter } from '../../atoms/lightbox/lightbox';
// import { Swiper } from 'swiper';
// import { Navigation, Pagination } from 'swiper/modules';
// import { A11y } from '../../atoms/slider/modules/a11y/a11y.mjs';

const galleryEl = document.querySelectorAll('.media-gallery');
const lightboxInstances = [];
// const sliderInstances = [];

galleryEl.forEach(gallery => {
  // const uniqueStr = `${Math.floor(
  //   Math.random() * Math.floor(Math.random() * Date.now())
  // )}`;
  // const id = `media-gallery-${uniqueStr}`;

  // Lightbox

  const children = gallery.querySelectorAll('.media-gallery__lightbox-toggle');
  const lightboxInstance = new Lightbox({
    ...{ gallery, children },
    ...config,
    // on: {
    //   change: function () {
    //     Bus.broadcast('gallery_lightbox_change', {
    //       id,
    //       activeIndex: this.currIndex,
    //     });
    //   },
    // },
  });

  lightboxInstance.init();
  fixCounter(lightboxInstance);
  lightboxInstances.push(lightboxInstance);

  // Slider

  // const slider = $('.media-gallery-slider', gallery);
  // const sliderConfig = {
  //   modules: [A11y, Navigation, Pagination],
  //   loop: true,
  //   init: false,
  //   slidesPerView: 3,
  //   centeredSlides: true,
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  //   },
  //   pagination: {
  //     el: '.swiper-pagination',
  //     type: 'fraction',
  //     renderFraction: function (currentClass, totalClass) {
  //       return (
  //         '<span class="sr-only">Inhalt</span><span class="' +
  //         currentClass +
  //         ' slider__pagination-counter-current"></span>&nbsp;' +
  //         ' <span aria-hidden="true">/</span><span class="sr-only">von</span> ' +
  //         '&nbsp;<span class="' +
  //         totalClass +
  //         ' slider__pagination-counter-total"></span>'
  //       );
  //     },
  //   },
  // };

  // const sliderInstance = new Swiper(slider, sliderConfig);
  // sliderInstances.push(sliderInstance);
  // sliderInstance.init();

  // // Sync slider with lightbox slider

  // const syncSlider = e => {
  //   if (e.id !== id) return;
  //   if (sliderConfig.loop) {
  //     sliderInstance.slideToLoop(e.activeIndex);
  //     return;
  //   }
  //   sliderInstance.slideTo(e.activeIndex);
  // };

  // Bus.subscribe(
  //   'gallery_lightbox_change',
  //   `MediaGallerySlider-${uniqueStr}`,
  //   syncSlider
  // );
});
